"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBaseUrl = exports.setBaseUrl = exports.HttpMethod = exports.ContentType = void 0;
const tslib_1 = require("tslib");
var ContentType;
(function (ContentType) {
    ContentType["json"] = "application/json;charset=UTF-8";
    ContentType["form"] = "application/x-www-form-urlencoded; charset=UTF-8";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["get"] = "GET";
    HttpMethod["post"] = "POST";
    HttpMethod["put"] = "PUT";
    HttpMethod["patch"] = "PATCH";
    HttpMethod["delete"] = "DELETE";
})(HttpMethod = exports.HttpMethod || (exports.HttpMethod = {}));
// 请求baseUrl默认正式环境域名
let baseUrl = 'https://bookshelf.html5.qq.com';
/**
 * 设置baseUrl
 * @param {string} [url]
 */
exports.setBaseUrl = (url = '') => {
    baseUrl = url.replace(/(\/)+$/g, '');
};
/**
 * 获取baseUrl
 *
 */
exports.getBaseUrl = () => baseUrl;
const parseRes = (res) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const contentType = res.headers.get('Content-Type');
    // 判定返回的内容类型，做不同的处理
    if (contentType) {
        if (contentType.indexOf('json') > -1) {
            return yield res.json();
        }
        if (contentType.indexOf('text') > -1) {
            return yield res.text();
        }
        if (contentType.indexOf('form') > -1) {
            return yield res.formData();
        }
        if (contentType.indexOf('video') > -1) {
            return yield res.blob();
        }
    }
    return yield res.text();
});
const handleRes = (res) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const parsedRes = yield parseRes(res);
    // 如果res.ok，则请求成功
    if (res.ok) {
        return parsedRes;
    }
    // 请求失败，返回解析之后的失败的数据
    const error = parsedRes;
    throw error;
});
const $fetch = (url, config) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    let promise;
    let contentType = ContentType.json;
    /*
      如有设置替换Content-Type
    */
    if (config) {
        if (config['Content-Type'] !== undefined) {
            contentType = config['Content-Type'];
        }
        else if (config.method === HttpMethod.post) {
            contentType = ContentType.form;
        }
        ;
    }
    ;
    // 如果收到了一个绝对地址，直接使用该地址
    const reqUrl = /^https?:\/\//.test(url) ? url : baseUrl + url;
    const headers = new Headers({
        'Content-Type': contentType,
    });
    if (!(config === null || config === void 0 ? void 0 : config.method) || config.method === HttpMethod.get) {
        promise = yield fetch(reqUrl, {
            headers,
        });
    }
    else if (config.method === HttpMethod.post) {
        promise = yield fetch(reqUrl, {
            body: JSON.stringify(config.body),
            headers,
            method: HttpMethod.post,
        });
    }
    else {
        promise = yield fetch(reqUrl, {
            body: JSON.stringify(config.body),
            headers,
            method: config.method,
        });
    }
    return handleRes(promise);
});
exports.default = $fetch;
